import React from 'react';
import { useAuth } from '../../contexts/auth/AuthContext';
import { hasOpsPageAccess } from '../Navigation/constants/NavigationConfig';
import RouteRecovery from './RouteRecovery';

const RequirePermission = ({ permission, access, children }) => {
  const { hasPermission } = useAuth();
  const isAllowed = access
    ? hasOpsPageAccess(access, hasPermission)
    : hasPermission(permission);

  if (!isAllowed) {
    return <RouteRecovery variant="denied" />;
  }

  return children;
};

export default RequirePermission;
